import React from "react";
import styled from "styled-components";
import { colors } from "../../styles/variables";
import { Button, Tag, TagLabel, TagRightIcon } from "@chakra-ui/react";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { custom_date } from "../../utilities/customDate";
import { ReactComponent as ExportOrange } from "../../assets/icons/ExportOrange.svg";
import { ArrowUpIcon } from "@chakra-ui/icons";

const ExportToExcelTags = ({ fileName, tableData }) => {
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  const exportToCSV = (tableData, fileName) => {
    const copiedTableData = [...tableData];
    const mappedArray = copiedTableData.map((obj) => {
      const newObj = { ...obj };

      Object.keys(newObj).forEach((key) => {
        if (newObj[key] === null) {
          newObj[key] = "N/A";
        }

        delete newObj.City;
        delete newObj.Address;
        delete newObj.Apartment;
        delete newObj.Containers;
        delete newObj.Units;
        delete newObj.Letter;
        delete newObj.StreetNumber;
        delete newObj.PostalCode;
        delete newObj.Id;
        delete newObj.StreetName;
        delete newObj.Adress;
        delete newObj.HouseholdId;
      });
      newObj.Created = custom_date(newObj.Created);
      return newObj;
    });

    console.log(mappedArray);

    const ws = XLSX.utils.json_to_sheet(mappedArray);
    XLSX.utils.sheet_add_aoa(
      ws,
      [["Internal-Id", "Ekternal-Id", "Eier", "Opprettet"]],
      {
        origin: "A1",
      }
    );
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };
  return (
    <Button
      rightIcon={<ArrowUpIcon />}
      colorScheme="orange"
      size={"xs"}
      variant={"outline"}
      onClick={(e) => exportToCSV(tableData, fileName)}
    >
      Eksporter tabellen
    </Button>
  );
};

export default ExportToExcelTags;
